module.exports = __webpack_public_path__ + "img/DK31050162.2ab91df3.png";